import {FC, ReactElement, useEffect, useState} from 'react';
import styled from 'styled-components';
import {useDispatch, useSelector} from 'react-redux';
import {getUserInfo} from '@/state/base/reducer';
import {AppState} from '@/state';
import home_tips_bg from '../../assets/images/home_tips_bg.png'
import Server from "utils/serviceApi";
import LoadingModal from "components/LoadingModal";
import {useTranslation} from "react-i18next";
import TipsModal from "components/TipsModal";
import {useHistory} from "react-router-dom";

const Home: FC = (): ReactElement => {
    const {t} = useTranslation();
    const history = useHistory()
    const {account} = useSelector((state: AppState) => state.baseInfo)
    const {
        getTableRowsByNFT,
        getTableRowsByOrders,
        getTableRowsByVendorinfo,
        getCheckData
    } = Server
    const [loadingVal, setLoadingVal] = useState('')
    const [tipsVisible, setTipsVisible] = useState<boolean>(false)
    const dispatch = useDispatch();

    const connectWallt = () => {
        dispatch(getUserInfo());
    }
    useEffect(() => {
        const initData = async () => {
            if (account.name) {
                setLoadingVal(t('home.Waiting'))
                const vendorinfoData = await getTableRowsByVendorinfo()
                const userChargeQuant = vendorinfoData.rows[0].user_charge_quant
                const chargeAmountVal = vendorinfoData.rows[0].user_charge_quant.split(' ')[0]
                const amountUnit = vendorinfoData.rows[0].user_charge_quant.split(' ')[1]
                const vendorAccount = vendorinfoData.rows[0].vendor_account
                const kycLevel = vendorinfoData.rows[0].kyc_level
                const nft_id = vendorinfoData.rows[0].nft_id.id
                try {
                    const nftData = await getTableRowsByNFT(account.name)
                    let nftAmount = 0
                    if (nftData && nftData.rows) {
                        const nftObj = nftData.rows.find(item => item.balance.symbol.id === nft_id)
                        if (nftObj) {
                            nftAmount = nftObj.balance.amount
                        }
                    }
                    if (nftAmount > 0) {
                        setLoadingVal('')
                        history.push('/succeed')
                    } else {
                        const ordersData = await getTableRowsByOrders(account.name)
                        if (ordersData.rows.length > 0) {
                            const responseCheck = await getCheckData({
                                parms: {
                                    sercet: '',
                                    userId: account.name
                                },
                                checkerType:'realme',
                                signData: ''
                            })
                            if (responseCheck.code === 200) {
                                if (responseCheck.data === 'Success' || responseCheck.data === 'Failure' || responseCheck.data === 'IdNumberDuplicate' || responseCheck.data === 'Pending') {
                                    setLoadingVal('')
                                    history.push('/verifying')

                                } else {
                                    setLoadingVal('')
                                    history.push('/certification', {
                                        initInfo: {
                                            hasPay: true,
                                            user_charge_quant: userChargeQuant,
                                            charge_amount_val: chargeAmountVal,
                                            amount_unit: amountUnit,
                                            vendor_account: vendorAccount,
                                            kyc_level: kycLevel
                                        }
                                    })
                                }

                            } else {
                                setLoadingVal('')
                                history.push('/certification', {
                                    initInfo: {
                                        hasPay: true,
                                        user_charge_quant: userChargeQuant,
                                        charge_amount_val: chargeAmountVal,
                                        amount_unit: amountUnit,
                                        vendor_account: vendorAccount,
                                        kyc_level: kycLevel
                                    }
                                })
                            }

                        } else {
                            setLoadingVal('')

                            history.push('/certification', {
                                initInfo: {
                                    hasPay: false,
                                    user_charge_quant: userChargeQuant,
                                    charge_amount_val: chargeAmountVal,
                                    amount_unit: amountUnit,
                                    vendor_account: vendorAccount,
                                    kyc_level: kycLevel
                                }
                            })
                        }

                    }
                } catch (e) {
                    setLoadingVal('')
                    history.push('/certification', {
                        initInfo: {
                            hasPay: true,
                            user_charge_quant: userChargeQuant,
                            charge_amount_val: chargeAmountVal,
                            amount_unit: amountUnit,
                            vendor_account: vendorAccount,
                            kyc_level: kycLevel
                        }
                    })
                }


            }
        }


        void initData()
    }, [account.name, getTableRowsByVendorinfo, getTableRowsByNFT, t, history, getCheckData, getTableRowsByOrders])
    return (
        <Main>

            <ConnectWallt>
                <LogoTextImg src={require('img/home_logo_text.png').default} alt=""/>
                <LogoText>{t('home.decentralized')}</LogoText>
                <IdCardText>{t('home.IDBlock')}</IdCardText>
                <IdCardImg src={require('img/home_id_img.png').default} alt=""/>
                <ConnectBtn onClick={connectWallt}>
                    <div>
                        {t('layout.connect')}
                    </div>
                </ConnectBtn>
                <ConnectTip>

                    <div className='content-data'>
                        <p>{t('home.getA')} <span>DID-NFT</span>{t('home.getOther')}<span>DID-NFT</span></p>
                        <p style={{marginTop: '0.04rem'}}>{t('home.validCertificate')}</p>
                    </div>

                    <div className='tip-txt' onClick={() => setTipsVisible(true)}>
                        <TipsImg src={require('img/tips_icon.svg').default} alt=""/>
                        DID-NFT {t('home.transferredOthers')}
                    </div>

                </ConnectTip>
            </ConnectWallt>
            {loadingVal && <LoadingModal content={loadingVal}/>}
            {tipsVisible && <TipsModal onClose={() => setTipsVisible(false)}/>}
        </Main>
    );
};

const Main = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const ConnectWallt = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  height: 100%;
  padding: 0.81rem 0.16rem 0 0.16rem;
`;

const LogoTextImg = styled.img.attrs(props => ({
    src: props.src,
    alt: props.alt,
}))`
  height: 0.4rem;
`;

const LogoText = styled.p`
  font-size: 0.12rem;
  color: #A1A1B3;
  margin-top: 0.08rem;
`;


const IdCardText = styled.p`
  font-size: 0.2rem;
  color: #161617;
  line-height: 0.28rem;
  align-self: center;
  margin-top: 0.16rem;
`;


const IdCardImg = styled.img.attrs(props => ({
    src: props.src,
    alt: props.alt,
}))`
  width: 70%;
`;

const TipsImg = styled.img.attrs(props => ({
    src: props.src,
    alt: props.alt,
}))`
  width: 0.16rem;
  height: 0.16rem;
  margin-right: 0.04rem;
`;

const ConnectTip = styled.div`
  position: relative;
  width: 100%;
  flex: 1;
  font-size: 0.13rem;
  font-family: PingFang SC-Bold, PingFang SC;
  text-align: left;
  margin-top: 0.2rem;
  background: url(${home_tips_bg}) no-repeat center;
  background-size: 100% 100%;
  color: #58585E;
  line-height: 0.18rem;

  span {
    color: #08BDC7;
  }

  .content-data {
    padding: 0.16rem 0.12rem;
  }

  .tip-txt {
    position: absolute;
    bottom: 0.24rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.12rem;
    font-weight: 400;
    color: #A1A1B3;
  }
`;

const ConnectBtn = styled.div`
  width: 90%;
  height: 44px;
  background: linear-gradient(135deg, #49ADFF 0%, #1DEECE 100%);
  box-shadow: 0px 4px 10px 0px rgba(67, 178, 203, 0.2);
  border-radius: 22px;
  text-align: center;
  line-height: 32px;
  font-weight: 600;
  color: #FFFFFF;
  padding: 5px 6px;
  width: 90%;

  div {
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.24) 0%, rgba(255, 255, 255, 0) 100%);
    box-shadow: 0px 4px 10px 0px rgba(67, 178, 203, 0.2);
    border-radius: 22px;
  }
`;

export default Home;
